











































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import LocationPanelMobileNavItem from '@/components/location/location-panel/location-panel-mobile/LocationPanelMobileNavItem.vue';
import LocationModel from '@/location/Location';
import { namespace } from 'vuex-class';
import Category from '@/category/Category';
import LocationPanelMarkerItem from '@/components/location/location-panel/location-panel-item/LocationPanelMarkerItem.vue';
import LocationPanelStudyItem from '@/components/location/location-panel/location-panel-item/LocationPanelStudyItem.vue';
import Marker from '@/marker/Marker';
import LocationPanelMobileNavItemBody from '@/components/location/location-panel/location-panel-mobile/LocationPanelMobileNavItemBody.vue';
import CategoriesWithMarkers from '@/mixins/CategoriesWithMarkers';
import Chevron from '@/assets/icons/chevron.svg';

const Locations = namespace('locations');

@Component({
    components: {
        Chevron,
        LocationPanelMobileNavItemBody,
        LocationPanelMarkerItem,
        LocationPanelStudyItem,
        LocationPanelMobileNavItem,
    },
})
export default class LocationPanelMobileNav extends Mixins(CategoriesWithMarkers) {
    @Locations.Getter
    mobileMenuOpened!: boolean | null;

    @Locations.Getter
    activeLocationPanelItem!: string | null;

    @Locations.Mutation
    toggleMobileMenu!: (isOpened?: boolean) => void;

    @Prop({ type: LocationModel, required: true })
    location!: LocationModel;

    public $refs!: {
        navScrollList: HTMLElement;
    };

    @Watch('$route.params.location', { immediate: true, deep: true })
    private onRouteChange(newValue: string, oldValue: string) {
        if (newValue !== oldValue) {
            this.resetScrollListPosition();
        }
    }

    private resetScrollListPosition(): void {
        if (this.$refs.navScrollList) {
            this.$refs.navScrollList.scrollLeft = 0;
        }
    }

    private get isAboutInfo(): boolean {
        return this.activeLocationPanelItem === this.location.id;
    }

    private get isStudiesInfo(): boolean {
        return this.activeLocationPanelItem === `${this.location.id}-studies`;
    }

    private get currentCategory(): Category {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.categories.find(c => c.id === this.activeLocationPanelItem)!;
    }

    private get currentMarkers(): Array<Marker> {
        const categoryId = this.activeLocationPanelItem;
        const locationId = this.$route.params.location;

        return Marker.query()
            .where((marker: Marker) => {
                return marker.category_id === categoryId && marker.location_id === locationId;
            })
            .withAllRecursive()
            .get();
    }
}
